module.exports = ".dropdown-item {\n    cursor:pointer;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/articles/articles.component.css
// module id = ./src/app/articles/articles.component.css
// module chunks = main